import Node from 'ln/node/Node';
import UserSequencModel from '../models/UserSequenceModel';
import CustomBase from './CustomBase';
import CustomUserSequenceModel from '../models/CustomUserSequenceModel';
import Course from './Course';
import UserFileList from './UserFileList';

class CustomUserSequence extends CustomBase {

	public userFileList:UserFileList;

	constructor( public model:CustomUserSequenceModel, courseView: Course ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

		// userfile list
		this.userFileList = new UserFileList( this.model as UserSequencModel );
		this.userFileList.render();
		this.node.js( 'userfiles' ).append( this.userFileList.node );

		this.node.js( 'endbehaviour' ).blur.add( this.onEndbehaviourChange, this );
		this.node.js( 'method' ).blur.add( this.onMethodChange, this );
		this.node.js( 'socialform' ).blur.add( this.onSocialformChange, this );
		this.node.js( 'material' ).blur.add( this.onMaterialChange, this );
		this.node.js( 'teacher-directions' ).blur.add( this.onTeacherDirectionsChange, this );
		this.node.js( 'notes' ).blur.add( this.onNoteChange, this );
		

		this.node.js('expand').click.add(() => {
			this.node.toggleClass( 'expanded' );
		});

	}

	private onEndbehaviourChange( n:Node ){
		this.model.endbehaviour = n.html;
		this.model.save();
	}

	private onTeacherDirectionsChange( n:Node ){
		this.model.teacher_directions = n.html;
		this.model.save();
	}

	private onMethodChange( n:Node ){
		this.model.method = n.html;
		this.model.save();
	}

	private onSocialformChange( n:Node ){
		this.model.socialform = n.html;
		this.model.save();
	}

	private onMaterialChange( n:Node ){
		this.model.material = n.html;
		this.model.save();
	}
	
	/**
	 * Callback when the note has changed
	 */
	private onNoteChange( n:Node ) {
		this.model.note = n.html;
		this.model.save();
	}
}

export default CustomUserSequence;